import React from 'react'
import { P } from '@modul-connect/shared/components/atoms/text'
import View from '@modul-connect/shared/components/atoms/view'
import theme from '@modul-connect/shared/theme'

export const RoleExplanation = () => {
  return (
    <View style={{ margin: '18px 24px 10px 24px', padding: '8px 12px', height: 'auto', backgroundColor: theme.colors.barBackground, borderRadius: '8px' }}>
      <View>
        <P small noPadding extend={{ fontWeight: 500 }}>Role explanation</P>
        {/* <P small extend={{fontStyle: 'italic', margin: '10px 0', '& strong': { fontWeight: 500 }}}><strong>Admin:</strong> Can manage groups, users and applications</P> */}
        <P small extend={{ fontStyle: 'italic', margin: '10px 0', '& strong': { fontWeight: 500 } }}><strong>Manager:</strong> Can manage users and applications within the group</P>
        <P small extend={{ fontStyle: 'italic', margin: '10px 0', '& strong': { fontWeight: 500 } }}><strong>User:</strong> Can manage their own applications</P>
      </View>
    </View>
  )
}